import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
import moment from 'moment';

const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
const apiClientDownload = axios.create({
  baseURL: '',
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  missionTriageAnswerFor115: [],
  allCurrentAddressForForm: [],
  selectedAnswersFromTriage: [],
  errorStatus: null,
  sentMission: null,
  allAttachment: [],
  mission115: null,
  times: null,
  dispathMissionTopList: [],
  dispatchCode: null,
  missionAttachList: null,
  listOfRecentCalls115: [],
  missionConfirmations: [],
  missionAddedTag: null,
  missionReportInfo: [],
  missionCalls: [],
  missionTriages: [],
  missionLogs: [],
  totalPages: 0,
  totalRecords: 0,
  mission115Detail: null,
  currentNurseDiagnosis: {},
};
const getters = {
  getApiLoad_46: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_MissionTriageAnswer(state, missions) {
    state.missionTriageAnswerFor115 = missions;
  },
  SET_MissionClinicalTriage(state, missions) {
    state.missionTriageAnswerFor115 = missions;
  },
  SET_AllCurrentAddressForForm(state, missions) {
    state.allCurrentAddressForForm = missions;
  },
  SET_AllAttachment(state, missions) {
    state.allAttachment = missions;
  },
  SET_SendToDispatch(state, missions) {
    state.sentMission = missions;
  },
  Set_115Mission(state, data) {
    state.mission115 = data;
  },
  SET_Time(state, data) {
    state.times = data;
  },
  SET_DispatchTopList(state, data) {
    state.dispathMissionTopList = data;
  },
  SET_DispatchCode(state, data) {
    state.dispatchCode = data;
  },
  SET_MissionAttach(state, data) {
    state.missionAttachList = data;
  },
  SET_RecentCalls115(state, data) {
    state.listOfRecentCalls115 = data;
  },
  SET_MissionAddedTag(state, data) {
    state.missionAddedTag = data;
  },
  SET_MissionReport(state, data) {
    state.missionReportInfo = data.items;
    state.totalPages = data.totalPages;
    state.totalRecords = data?.totalRecords ?? 0;
  },
  SET_MissionCalls(state, data) {
    state.missionCalls = data;
  },
  SET_missionConfirmation(state, data) {
    state.missionConfirmations = data;
  },
  SET_MissionTriages(state, data) {
    state.missionTriages = data;
  },
  SET_MissionLogs(state, data) {
    state.missionLogs = data;
  },
  SET_Mission115Detail(state, data) {
    state.mission115Detail = data;
  },
  SET_CurrentNurseDiagnosis(state, data) {
    state.currentNurseDiagnosis = data;
  },
  SET_SelectedTriageAnswers(state, triageAnswers) {
    state.selectedAnswersFromTriage = triageAnswers;
  },
};
const actions = {
  errorMission({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  missionTriageAnswer115({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Missions/TriageAnswer', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_MissionTriageAnswer', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },
  setClinicalTriageFor115Misssion({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Missions/ClinicalTriage', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        //commit('SET_MissionClinicalTriage', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },
  getAllCurrentAddressForForm({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Missions/CurrentAddresses', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllCurrentAddressForForm', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },
  getAllAttachmentMission({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Missions/CurrentAddressesForAttachment', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllAttachment', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },
  getMissionBy115({ commit, dispatch, rootState }, { missionId, missionPhoneId }) {
    let url = '/Missions/By115?MissionId=' + missionId;
    if (missionPhoneId) {
      url += '&MissionPhoneId=' + missionPhoneId;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('Set_115Mission', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },
  setCurrentNurseDiagnosis({ commit }, data) {
    commit('SET_CurrentNurseDiagnosis', data);
  },
  setSelectedTriageAnswersDispatch({ commit }, data) {
    commit('SET_SelectedTriageAnswers', data);
  },
  sendMissionToDispatch({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Missions/SendToDispatch', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_SendToDispatch', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },
  endCall({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Missions/EndCall', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },
  finalizeMission({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Missions/Finalize', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },
  deploymentMission({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Missions/Deployment', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },
  edit115Mission({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Missions/Modify', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },
  getMissionTime({ commit, dispatch, rootState }, { missionId, missionPhoneId }) {
    let url = '/Missions/Times?missionId=' + missionId;
    if (missionPhoneId) {
      url += '&missionPhoneId=' + missionPhoneId;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_Time', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },
  getDispatchTopList({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Missions/DispatchTopList', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_DispatchTopList', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },
  getDispatchCodeBy800User({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/Missions/DispatchCode?missionId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_DispatchCode', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },

  getMissionAttach800User({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/Missions/AttachList?missionId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_MissionAttach', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },

  removeSelectedZone800({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/Missions/RemoveSelectedZone?missionId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },
  removeMissionBy800({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Missions/Remove', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },
  attachMissionBy800User({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Missions/Attach', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },
  missionStarredBy800({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/Missions/StarredZone?missionId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },
  removeMissionStarredBy800({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/Missions/RemoveStarredZone?missionId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },
  getRecentCalls115({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Missions/RecentCalls', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_RecentCalls115', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },
  addToMissionTag({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Missions/Tag', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_MissionAddedTag', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },
  removeTagFromMission({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/Missions/RemoveTag?missionTagId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },
  downloadAttachment_New({ commit, dispatch, rootState }, path) {
    if (!path) {
      console.warn('⚠️ No file path provided');
      commit('SET_Status', false);
      return Promise.reject(new Error('آدرس فایل وجود ندارد'));
    }

    return apiClientDownload
      .get(path, {
        headers: {
          'X-CSRF-Token': rootState.loginModule.csrf,
        },
        responseType: 'blob',
        timeout: 30000,
      })
      .then((response) => {
        if (response.status === 401) {
          throw new Error('Unauthorized');
        }
        if (response.status === 404) {
          throw new Error('Not Found');
        }

        const blob = new Blob([response.data]);

        let extension = 'jpg';

        const pathParts = path.split('.');
        if (pathParts.length > 1) {
          extension = pathParts[pathParts.length - 1].split('?')[0];
        }

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${moment().format('HH-mm-ss_jYYYY-jM-jD')}.${extension}`;

        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        }, 1000);

        commit('SET_Status', true);
        return { success: true, extension };
      })
      .catch((error) => {
        console.error('❌ Download error:', error);
        commit('SET_Status', false);

        let errorMessage = 'خطا در دانلود فایل';
        if (error.response?.status === 401) {
          errorMessage = 'شما اجازه دسترسی به این فایل را ندارید';
        } else if (error.response?.status === 404) {
          errorMessage = 'فایل یافت نشد';
        } else if (error.message === 'Network Error') {
          errorMessage = 'مشکل در ارتباط با سرور';
        }

        dispatch('errorMission', {
          message: errorMessage,
          originalError: error
        });

        throw error;
      });
  },
  getMissionReport(
    { commit, dispatch, rootState },
    {
      pageNumber,
      pageSize,
      missionIdentifier,
      fullName,
      mainPhoneNumber,
      otherPhoneNumber,
      phoneCode,
      tagId,
      rank,
      address,
      fromDate,
      toDate,
      missionId,
      isUnknown,
      currentUserReport,
      patientResult,
      diagnosisId,
      searchCityId
    },
  ) {
    let url = '/Missions/Report?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (missionIdentifier) {
      url += '&MissionIdentifier=' + missionIdentifier;
    }
    if (fullName) {
      url += '&FullName=' + fullName;
    }
    if (mainPhoneNumber) {
      url += '&MainPhoneNumber=' + mainPhoneNumber;
    }
    if (otherPhoneNumber) {
      url += '&OtherPhoneNumber=' + otherPhoneNumber;
    }
    if (phoneCode) {
      url += '&PhoneCode=' + phoneCode;
    }
    if (tagId) {
      url += '&TagId=' + tagId;
    }
    if (rank != null && rank != undefined) {
      url += '&Rank=' + rank;
    }
    if (address) {
      url += '&Address=' + address;
    }
    if (fromDate) {
      url += '&FromDate=' + fromDate;
    }
    if (toDate) {
      url += '&ToDate=' + toDate;
    }
    if (isUnknown) {
      url += '&isUnknown=' + isUnknown;
    }
    if (currentUserReport) {
      url += '&currentUserReport=' + currentUserReport;
    }
    if (patientResult) {
      url += '&patientResult=' + patientResult;
    }
    if (diagnosisId) {
      url += '&diagnosisId=' + diagnosisId;
    }
    if (searchCityId) {
      url += '&cityId=' + searchCityId;
    }
    return apiClient
      .get(url, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
        params: { missionId },
      })
      .then((response) => {
        commit('SET_MissionReport', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },
  getMissionCalls({ commit, dispatch, rootState }, missionId) {
    let url = '/Missions/calls?missionId=' + missionId;
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_MissionCalls', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },
  getMissionConfirmationDispatch({ commit, dispatch, rootState }, params) {
    return apiClient
      .get('/Missions/LocationConfirmation', {
        params,
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_missionConfirmation', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },
  getMissionTriages({ commit, dispatch, rootState }, missionId) {
    let url = '/Missions/Triages?missionId=' + missionId;
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_MissionTriages', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },
  getMissionLogs({ commit, dispatch, rootState }, { missionId, missionPhoneId }) {
    let url = '/Missions/Logs?missionId=' + missionId;
    if (missionPhoneId) {
      url += '&missionPhoneId=' + missionPhoneId;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_MissionLogs', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },
  getMission115Detail({ commit, dispatch, rootState }, missionId) {
    let url = '/Missions/Details115?missionId=' + missionId;
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_Mission115Detail', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },
  sendPationtNewLocation({ commit, dispatch, rootState }, data) {
    let url = '/Missions/Location';
    return apiClient
      .post(url, data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorMission', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
